import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import '../styles/LoginPage.css';

export default function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            await api.post('/auth/forgot-password', { email });
            setSent(true);
        } catch {
            setError('Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 8, textDecoration: 'none', marginBottom: 24 }}>
                <span style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--color-primary)', display: 'inline-block' }} />
                <span style={{ fontWeight: 700, fontSize: 18, color: 'var(--color-text)' }}>Scalewisp</span>
            </Link>

            <h2 style={{ margin: '0 0 4px', fontSize: 22, fontWeight: 800, letterSpacing: '-0.01em' }}>Passwort vergessen?</h2>
            <p style={{ margin: '0 0 24px', color: 'var(--color-text-secondary)', fontSize: 14 }}>
                Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen.
            </p>

            {sent ? (
                <div style={{ padding: '14px 16px', background: 'rgba(34,197,94,0.1)', border: '1px solid rgba(34,197,94,0.25)', borderRadius: 8, fontSize: 14, color: 'var(--color-text)' }}>
                    Falls ein Konto mit dieser E-Mail existiert, wurde eine E-Mail gesendet. Bitte prüfen Sie auch Ihren Spam-Ordner.
                </div>
            ) : (
                <form onSubmit={handleSubmit} className="login-form">
                    <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4, color: 'var(--color-text)' }}>
                        E-Mail-Adresse
                    </label>
                    <input
                        type="email"
                        placeholder="ihre@email.de"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        required
                        className="login-input"
                    />
                    <button
                        className="button"
                        type="submit"
                        disabled={loading || !email}
                        style={{ background: 'var(--color-primary)', color: '#fff', padding: '10px', fontWeight: 600, fontSize: 15, borderRadius: 8 }}
                    >
                        {loading ? 'Wird gesendet…' : 'Link senden'}
                    </button>
                    {error && <p className="login-error">{error}</p>}
                </form>
            )}

            <p style={{ textAlign: 'center', marginTop: 20, fontSize: 13, color: 'var(--color-text-secondary)' }}>
                <Link to="/login" style={{ color: 'var(--color-primary)', fontWeight: 600, textDecoration: 'none' }}>← Zurück zur Anmeldung</Link>
            </p>
        </div>
    );
}
